"use strict";

var IntegrationTitle = React.createClass({
  propTypes: {
    title: React.PropTypes.string.isRequired,
    tag: React.PropTypes.oneOf(["new", "beta"])
  },

  getTag: function(tag) {
    if(tag != null){
      if(tag == "new"){
        var text = "Novidade!";
        var classNameColor = "red";
      } else if(tag == "beta") {
        var text = "Beta!"
        var classNameColor = "orange";
      }
      return (<span className={"ml-5 tag " + classNameColor}>{text}</span>);
    }
  },

  render: function() {
    return (
      <div className="integrationTitle mb-20">
        <h3 className="d-ib">{this.props.title}</h3>
        {this.getTag(this.props.tag)}
      </div>
    );
  }
});

module.exports = IntegrationTitle;



// WEBPACK FOOTER //
// ./app/screens/Integration/shared/components/integration-title.jsx